import { render } from "./PositiveList.vue?vue&type=template&id=1a93c967"
import script from "./PositiveList.vue?vue&type=script&lang=js"
export * from "./PositiveList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\csit142\\source\\repos\\Website.TorbayDesignGuide\\Website.TorbayDesignGuide.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__